import {
  PSMS_PA_CASE_SUBMISSION_REQUEST,
  PSMS_PA_CASE_SUBMISSION_SUCCESS,
  PSMS_PA_CASE_SUBMISSION_FAILURE,
  PSMS_PA_CASE_SUBMISSION_LOADING,
  PSMS_PA_CASE_SUBMISSION_CHANNEL_REQUEST,
  PSMS_PA_CASE_SUBMISSION_CHANNEL_SUCCESS,
  PSMS_PA_CASE_SUBMISSION_CHANNEL_FAILURE,
  PSMS_PA_CASE_SUBMISSION_CHANNEL_LOADING,
  PSMS_PA_APPROVAL_DENIAL_TREND_REQUEST,
  PSMS_PA_APPROVAL_DENIAL_TREND_SUCCESS,
  PSMS_PA_APPROVAL_DENIAL_TREND_FAILURE,
  PSMS_PA_APPROVAL_DENIAL_TREND_LOADING,
  PSMS_PA_TAT_TREND_REQUEST,
  PSMS_PA_TAT_TREND_SUCCESS,
  PSMS_PA_TAT_TREND_FAILURE,
  PSMS_PA_TAT_TREND_LOADING,
} from '../../../actions/actionTypes';

interface PsmsPAState {
  caseSubmissionData: any;
  isLoading: boolean;
  error: string | null;
  caseSubmissionChannelData: any;
  isChannelLoading: boolean;
  channelError: string | null;
  approvalDenialTrendData: any;
  isApprovalDenialTrendLoading: boolean;
  approvalDenialTrendError: string | null;
  tatTrendData: any;
  isTatTrendLoading: boolean;
  tatTrendError: string | null;
}

const initialState: PsmsPAState = {
  caseSubmissionData: null,
  isLoading: true,
  error: null,
  caseSubmissionChannelData: null,
  isChannelLoading: true,
  channelError: null,
  approvalDenialTrendData: null,
  isApprovalDenialTrendLoading: true,
  approvalDenialTrendError: null,
  tatTrendData: null,
  isTatTrendLoading: true,
  tatTrendError: null,
};

const psmsPAReducer = (
  state = initialState,
  action: { type: string; payload?: any }
): PsmsPAState => {
  switch (action.type) {
    case PSMS_PA_CASE_SUBMISSION_REQUEST:
      return {
        ...state,
        isLoading: true,
        caseSubmissionData: null,
        error: null,
      };

    case PSMS_PA_CASE_SUBMISSION_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };

    case PSMS_PA_CASE_SUBMISSION_SUCCESS:
      return {
        ...state,
        caseSubmissionData: action.payload,
        isLoading: false,
        error: null,
      };

    case PSMS_PA_CASE_SUBMISSION_FAILURE:
      return {
        ...state,
        isLoading: false,
        caseSubmissionData: null,
        error: action.payload,
      };

    case PSMS_PA_CASE_SUBMISSION_CHANNEL_REQUEST:
      return {
        ...state,
        isChannelLoading: true,
        caseSubmissionChannelData: null,
        channelError: null,
      };

    case PSMS_PA_CASE_SUBMISSION_CHANNEL_LOADING:
      return {
        ...state,
        isChannelLoading: action.payload,
      };

    case PSMS_PA_CASE_SUBMISSION_CHANNEL_SUCCESS:
      return {
        ...state,
        caseSubmissionChannelData: action.payload,
        isChannelLoading: false,
        channelError: null,
      };

    case PSMS_PA_CASE_SUBMISSION_CHANNEL_FAILURE:
      return {
        ...state,
        isChannelLoading: false,
        caseSubmissionChannelData: null,
        channelError: action.payload,
      };

    case PSMS_PA_APPROVAL_DENIAL_TREND_REQUEST:
      return {
        ...state,
        isApprovalDenialTrendLoading: true,
        approvalDenialTrendData: null,
        approvalDenialTrendError: null,
      };

    case PSMS_PA_APPROVAL_DENIAL_TREND_LOADING:
      return {
        ...state,
        isApprovalDenialTrendLoading: action.payload,
      };

    case PSMS_PA_APPROVAL_DENIAL_TREND_SUCCESS:
      return {
        ...state,
        approvalDenialTrendData: action.payload,
        isApprovalDenialTrendLoading: false,
        approvalDenialTrendError: null,
      };

    case PSMS_PA_APPROVAL_DENIAL_TREND_FAILURE:
      return {
        ...state,
        isApprovalDenialTrendLoading: false,
        approvalDenialTrendData: null,
        approvalDenialTrendError: action.payload,
      };

    case PSMS_PA_TAT_TREND_REQUEST:
      return {
        ...state,
        isTatTrendLoading: true,
        tatTrendData: null,
        tatTrendError: null,
      };

    case PSMS_PA_TAT_TREND_LOADING:
      return {
        ...state,
        isTatTrendLoading: action.payload,
      };

    case PSMS_PA_TAT_TREND_SUCCESS:
      return {
        ...state,
        tatTrendData: action.payload,
        isTatTrendLoading: false,
        tatTrendError: null,
      };

    case PSMS_PA_TAT_TREND_FAILURE:
      return {
        ...state,
        isTatTrendLoading: false,
        tatTrendData: null,
        tatTrendError: action.payload,
      };

    default:
      return state;
  }
};

export default psmsPAReducer;
